import { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class Option extends Component {
}
Option.propTypes = {
    /**
     * 选项值
     */
    value: PropTypes.any,
};
Option.__PRO_OPTION = true;
